module.exports = __webpack_public_path__ + "180fd0b75a82e0bcdbae7f914bda850a.svg";